// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallNotes_wrapper__1ukxM","header":"CallNotes_header__Ge4U0"};